export default "__VITE_ASSET__BWfIF_07__"